import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from '../styles.module.scss';

const Divider = ({ fullWidth, disabled }) => (
	<div
		className={cx(styles.divider, {
			[styles.fullWidth]: fullWidth,
			[styles.disabled]: disabled
		})}
	/>
);

Divider.propTypes = {
	fullWidth: PropTypes.bool,
	disabled: PropTypes.bool
};

export default Divider;
